import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51907888972078:1';
export function ProductSection() {
  const handleCTAClick = () => {
    console.log('InitiateCheckout tracked');
  };
  return <section className="bg-[#FAF7F2] py-16 px-5" data-id="element-212">
      <div className="max-w-[900px] mx-auto" data-id="element-213">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-214">
          <div className="rounded-3xl overflow-hidden shadow-2xl" data-id="element-215">
            <img src="https://cdn.magicpatterns.com/uploads/qPdt8MSEiEJtJa2aNfFhuW/ChatGPT_Image_31_mar_2026,_07_45_59_p.m..png" alt="Su Primer Año — Protocolo B.E.B.E. 365" className="w-full object-cover" data-id="element-216" />
          </div>

          <div data-id="element-217">
            <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full mb-4 font-sans font-bold" data-id="element-218">
              El Ebook Principal
            </span>

            <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4" data-id="element-219">
              Su Primer Año:
              <br data-id="element-220" />
              Tu Bebé Te Necesita
            </h2>

            <p className="text-base text-[#6B4C3B] font-sans mb-6 leading-relaxed" data-id="element-221">
              Un protocolo de 60 páginas basado en neurociencia aplicada que
              integra los 4 pilares del desarrollo infantil en un sistema de
              alto rendimiento. Diseñado para padres modernos que valoran la
              ciencia, la eficiencia y los resultados reales.
            </p>

            <div className="flex flex-wrap gap-2.5 mb-8" data-id="element-222">
              {['📥 Descarga Inmediata', '⭐ Producto Premium', '📱 Compatible Móvil', '🌍 En Español'].map((tag, idx) => <span key={idx} className="bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-xs px-3.5 py-1.5 rounded-full font-sans font-bold tracking-wide" data-id="element-223">
                  {tag}
                </span>)}
            </div>

            <a href={CHECKOUT_URL} onClick={handleCTAClick} className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-lg font-bold py-4 px-8 rounded-full text-center tracking-wide shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse max-w-md" data-id="element-224">
              ⚡ OBTENER ACCESO AHORA →
            </a>
          </div>
        </div>
      </div>
    </section>;
}